import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=0b008bdd&scoped=true"
var script = {}
import style0 from "./Projects.vue?vue&type=style&index=0&id=0b008bdd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b008bdd",
  null
  
)

export default component.exports